import CargoTreatment from ".";

export const cargoTreatment = [
  {
    path: "/cargoTreatments",
    element: <CargoTreatment />,
  },
];
